/**
 * Public Vendors page — composition shell.
 *
 * All section content + the network-topology illustration live in
 * `./vendors/sections.jsx`. Their data tables live in `./vendors/data.js`.
 */
import VendorPartnershipVideo from "@/components/VendorPartnershipVideo";
import {
  VendorHero,
  VendorProblemSection,
  VendorSolutionSection,
  VendorHowItWorksSection,
  VendorValuePillarsSection,
  VendorProfilesSection,
  VendorEconomicsSection,
  VendorBoundariesSection,
  VendorGettingStartedSection,
  VendorFinalCtaSection,
} from "./vendors/sections";

export default function Vendors() {
  return (
    <div data-testid="vendors-page">
      <VendorHero />
      <VendorPartnershipVideo />
      <VendorProblemSection />
      <VendorSolutionSection />
      <VendorHowItWorksSection />
      <VendorValuePillarsSection />
      <VendorProfilesSection />
      <VendorEconomicsSection />
      <VendorBoundariesSection />
      <VendorGettingStartedSection />
      <VendorFinalCtaSection />
    </div>
  );
}
